import { render, staticRenderFns } from "./OutworkRatio.vue?vue&type=template&id=4107ccb6&scoped=true"
import script from "./OutworkRatio.vue?vue&type=script&lang=js"
export * from "./OutworkRatio.vue?vue&type=script&lang=js"
import style0 from "./OutworkRatio.vue?vue&type=style&index=0&id=4107ccb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4107ccb6",
  null
  
)

export default component.exports